// extracted by mini-css-extract-plugin
export var arrow = "ReCaptcha-module--arrow--c98f3";
export var arrowNo = "ReCaptcha-module--arrow_no--c9209";
export var arrowYes = "ReCaptcha-module--arrow_yes--b4fc0";
export var flex = "ReCaptcha-module--flex--98e86";
export var flex1 = "ReCaptcha-module--flex_1--c55c4";
export var flexCenter = "ReCaptcha-module--flex_center--0a5ff";
export var flexCenterCol = "ReCaptcha-module--flex_center_col--0b87e";
export var flexCol = "ReCaptcha-module--flex_col--cd707";
export var flexFixCenterCol = "ReCaptcha-module--flex_fix_center_col--c6c79";
export var flexFixedCenterCol = "ReCaptcha-module--flex_fixed_center_col--fba77";
export var reCaptchaContainer = "ReCaptcha-module--reCaptchaContainer--97b45";
export var reCaptchaIcon = "ReCaptcha-module--reCaptchaIcon--402ec";
export var reCaptchaText = "ReCaptcha-module--reCaptchaText--9055f";
export var rotating = "ReCaptcha-module--rotating--84f03";